import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Grid from "@material-ui/core/Grid";
import { Link, Typography } from "@material-ui/core";
import { techSupportLink } from "../constants";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 5,
        //position: "absolute",
        zIndex: 100,
    },
    footerText: {
        fontSize: 13,
        color: "#A5B5CB",
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center'
        }
    },
    footerTextContainer: {
        [theme.breakpoints.down('xs')]: {
            alignItems: 'center'
        }
    },
    mobileImageContainer: {
        display: 'none',
        [theme.breakpoints.down('sm')]: {
            display: 'block'
        }
    },
    imageContainer: {
        display: 'block',
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    },
    logoDesktopImage: {
        width: '40%',
        maxWidth: '200px',
        minWidth: '150px'
    },
    logoMobileImage: {
        width: '65%',
        maxWidth: '230px',
        minWidth: '200px'
    }
}))

const FooterComponent = (props) => {
    const classes = useStyles();
    const usageInfoPdfLink = 'https://itmo.ru/images/pages/79/Pravila_ispolzovanija_informacii.pdf';
    const personalInfoPdfLink = 'https://itmo.ru/file/pages/79/personal_data_policy.pdf';

    return (
        <footer>
            <Grid className={classes.root} container justifyContent={"space-between"} alignContent={"center"}
                  alignItems={"flex-end"}>
                <Grid item xs={12} sm={6}>
                    <Grid container direction={"column"} alignItems={"stretch"}
                          alignContent={"stretch"}>
                        <Grid item xs={12} md={12}>
                            <Typography
                                className={classes.footerText}
                                align={"left"}
                                variant={"body1"}>
                                <Link className={classes.footerText}
                                      target={"_blank"} href={techSupportLink}>
                                    Поддержка</Link>
                            </Typography>
                            <Typography
                                className={classes.footerText}
                                align={'left'}
                                variant={"body1"}
                                color={"textSecondary"}>
                                <Link className={classes.footerText}
                                      target={"_blank"} href={personalInfoPdfLink}>
                                    Политика обработки персональных данных</Link>
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Grid container direction={"column"} alignItems={"stretch"} className={classes.footerTextContainer}
                          alignContent={"stretch"}>
                        <Grid item>
                            <Typography
                                className={classes.footerText}
                                align={"right"}
                                variant={"body1"}>
                                © {new Date().getFullYear()} Университет ИТМО
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </footer>
    );
}

FooterComponent.propTypes = {};

export default FooterComponent;
